import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

const SessionsFAQItem = ({ className, question, response, expanded, onClick }) => {
  const cn = useClassNames(() => ['whitespace-pre-line', className], [className]);

  return (
    <li className={cn}>
      <button
        type="button"
        className={`text-left focus:outline-none${expanded ? ' font-semibold' : ''}`}
        onClick={onClick}
      >
        {question}
      </button>
      <div hidden={!expanded}>{response}</div>
    </li>
  );
};

SessionsFAQItem.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  question: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  response: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
};

SessionsFAQItem.defaultProps = {
  expanded: false,
  onClick: () => {},
};

export default SessionsFAQItem;
